import React, {useState, useEffect, useContext} from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import "./EffectSwiper.css";
import { getEffects } from "../../../../../../../utils/apis/effects/Effects";
import { Context } from "../../../../../../../utils/context";
import { IDS } from "../../../../../../../utils/common";

const categories = [
  { id: 1, name: "Electric", img: "/assets/images/gallary/img1.png" },
  { id: 2, name: "Fire", img: "/assets/images/gallary/img2.png" },
  { id: 4, name: "Electric", img: "/assets/images/gallary/img4.png" },
  { id: 5, name: "Air / Wind", img: "/assets/images/gallary/img5.png" },
  { id: 6, name: "Water", img: "/assets/images/gallary/img5.png" },
  { id: 7, name: "Dark / Shadow", img: "/assets/images/gallary/img5.png" },
  { id: 8, name: "Electric", img: "/assets/images/gallary/img4.png" },
  { id: 9, name: "Air / Wind", img: "/assets/images/gallary/img5.png" },
];

const EffectSwiper = () => {
  const [effect, setEffect] = useState([]);

  const { IMG_URL } = useContext(Context);

  const getEffect = async () => {
    const res = await getEffects();
    if (res?.success) {
      setEffect(res.data);
    }
  };
  useEffect(() => {
    getEffect();
  }, []);

  return (
    <div className="category-tabs-wrapper EffectSwiper-section">
      <div className="wrapper">
        <h3 className="title">Our Category Of Effects</h3>

        <div className="desktop-tabs ">
          <Swiper
            slidesPerView="auto"
            spaceBetween={15}
            // freeMode={true}
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            speed={2000}
            pagination={{
              clickable: true,
              el: ".custom-pagination",
            }}
            modules={[Autoplay, Pagination]}
          >
            {effect?.map((cat) => (
              <SwiperSlide key={cat.id} className="tab-slide">
                <div className="tab-item">
                  <div className="img-wrap">
                    <img src={IDS?.IMG_URL + cat.image} alt={cat?.name} />
                  </div>
                  <span>{cat?.name}</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="custom-pagination"></div>
      </div>
    </div>
  );
};

export default EffectSwiper;
